import React from "react";
import Slick from "react-slick";

import imgLogo from "../../assets/logo.png";

import "./styles.css";

const Render = (props, context) => {
  const settings = {
    infinite: false,
    arrows: true,
    dots: false,
    speed: 500,
    autoplay: false,
    centerMode: true,
    centerPadding: "60px",
    swipeToSlide: true,
    slidesToShow: 3,

    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <section className="preSite coverAll int selSuperheroe ptn">
      <div className="container">
        <img src={imgLogo} alt="Superheroes." className="logo displayBlock" />
        <h1 className="mbl avenirBK white">Seleccioná un personaje</h1>

        <Slick
          {...settings}
          className="seleccionUl horizontal clearfix mask pbl"
          afterChange={props.onChange}
        >
          {props.avatars.map(avatar => (
            <li key={avatar.id}>
              <img
                src={`${avatar.fullImage}`}
                alt="Superhéroe"
                className="displayBlock"
              />
            </li>
          ))}
        </Slick>
        <a onClick={props.onSubmit} className="mtl btn mha btnGold fontGold">
          Seleccionar
        </a>
      </div>
    </section>
  );
};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/SuperheroeSeleccionar/Render.js